var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMaximize = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5039 4166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-5039 -4166)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.765,27A1.809,1.809,0,0,1,7,25.235V8.765A1.809,1.809,0,0,1,8.765,7H25.235A1.809,1.809,0,0,1,27,8.765V25.235A1.809,1.809,0,0,1,25.235,27Zm0-1.765H25.235V8.765H8.765Zm0-16.471v0Z",
    transform: "translate(-5044 -4171)",
    fill: "#fff"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaximize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/maximize.168faea7.svg";
export { ForwardRef as ReactComponent };